import { isMoment } from 'moment';
import { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TermItem } from '../../../graphql/graphql';
import usePatient from '../../Patient/Hooks/usePatient';
import { getMomentDate } from '../../../Utils/dates.util';

export default function usePatientRegistration({
	formMethods,
	setIsChild,
	citizenshipOptions,
	isPrivateWorkplace = false,
}: {
	formMethods: UseFormReturn;
	setIsChild: (isChild: boolean) => void;
	citizenshipOptions?: TermItem[];
	isPrivateWorkplace?: boolean;
}) {
	const { checkIsAdultByInsuranceNumber, checkIsAdultByBirthDate } =
		usePatient();
	const [isBirthDateRequested, setIsBirthDateRequested] = useState(false);
	const [isGenderRequested, setIsGenderRequested] = useState(false);

	const citizenshipValue = formMethods.watch('citizenship')?.value;
	const birthDateValue = formMethods.watch('birthDate');
	const insuranceNumberValue = formMethods.watch('insuranceNumber');
	const healthPlanCodeValue = formMethods.watch('healthPlanCode')?.value;

	useEffect(() => {
		if (citizenshipOptions) {
			const otherTermItem: TermItem | undefined = citizenshipOptions.find(
				item => item.value === null,
			);
			const toggleValue = otherTermItem?.id === citizenshipValue;
			setIsBirthDateRequested(toggleValue);
			setIsGenderRequested(toggleValue);
			if (toggleValue) {
				setIsChild(false);
			} else {
				if (insuranceNumberValue && insuranceNumberValue?.length >= 6) {
					setIsChild(
						!checkIsAdultByInsuranceNumber(
							insuranceNumberValue,
							isPrivateWorkplace,
						),
					);
				}
			}
		}
	}, [citizenshipValue, isPrivateWorkplace]);

	useEffect(() => {
		const birthDateInMoment = getMomentDate(birthDateValue);
		if (birthDateInMoment.isValid()) {
			setIsChild(!checkIsAdultByBirthDate(birthDateInMoment));
		} else {
			setIsChild(false);
		}
	}, [birthDateValue]);

	return {
		isBirthDateRequested,
		isGenderRequested,
		insuranceNumberValue,
		healthPlanCodeValue,
	};
}
